import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const PayoutPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [payoutConfig, setPayoutConfig] = useState<any>({
    payoutApproveMode: 'manual',
    plugins: [
      { 
        id: 'ecuzen', 
        name: 'Ecuzen', 
        status: true, 
        transferMode: 'imps',
        keys: { token: '' }
      },
      { 
        id: 'cashfree', 
        name: 'Cashfree', 
        status: false, 
        transferMode: 'neft',
        keys: { clientId: '', clientSecret: '' }
      },
      { 
        id: 'returnpay', 
        name: 'ReturnPay', 
        status: false, 
        transferMode: 'imps',
        keys: { token: '' }
      }
    ]
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const getConfiguration = async () => {
    let result = await getConfigurationByName('payout_plugins')
    console.log(result)

    if (result.success) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      console.log(parsedData)
      setPayoutConfig({
        payoutApproveMode: parsedData.payoutApproveMode || 'manual',
        plugins: parsedData.plugins || []
      })
    }
  }

  const handleGlobalChange = (event: any) => {
    const {name, value} = event.target
    const updatedConfig = {...payoutConfig, [name]: value}
    setPayoutConfig(updatedConfig)
    updateConfiguration(updatedConfig)
  }

  const handlePluginChange = (pluginId: string, field: string, value: any, isNestedKey: boolean = false) => {
    const updatedPlugins = payoutConfig.plugins.map((plugin: any) => {
      if (plugin.id === pluginId) {
        if (isNestedKey) {
          return { ...plugin, keys: { ...plugin.keys, [field]: value } }
        }
        return { ...plugin, [field]: value }
      }
      return plugin
    })

    // Validation for auto mode
    if (field === 'status' && value === true && payoutConfig.payoutApproveMode === 'auto') {
      const activePlugins = updatedPlugins.filter((p: any) => p.status === true)
      if (activePlugins.length > 1) {
        ToastUtils({type: 'error', message: 'Only 1 plugin can be active in Auto mode'})
        return // Do not update state or db
      }
    }

    const updatedConfig = {...payoutConfig, plugins: updatedPlugins}
    setPayoutConfig(updatedConfig)
    if (field === 'status') {
      updateConfiguration(updatedConfig)
    }
  }
  
  const handlePluginBlur = () => {
    updateConfiguration(payoutConfig)
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='card'>
      <div className='card-title p-8'>
        <h2>Payout settings</h2>
      </div>
      <div className='card-body'>
        <div className='row no-gutters'>
          
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Payout Approve Mode</strong>
            </p>
            <p className='text-muted'>Select auto to process payouts automatically upon request.</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <select
                className='form-select form-select-solid fw-bolder'
                name='payoutApproveMode'
                value={payoutConfig.payoutApproveMode}
                onChange={handleGlobalChange}
              >
                <option value={'manual'}>Manual</option>
                <option value={'auto'}>Auto</option>
              </select>
            </div>
          </div>
          
        </div>
        
        <h3 className='mt-10 mb-5'>Payout Gateways</h3>
        {payoutConfig.plugins.map((plugin: any) => (
          <div className='row no-gutters border mb-5 rounded' key={plugin.id}>
             <div className='col-lg-12 card-body bg-light d-flex justify-content-between align-items-center'>
               <h4 className='m-0'>{plugin.name}</h4>
               <div className='form-check form-switch'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    role='switch'
                    checked={plugin.status}
                    onChange={(e) => handlePluginChange(plugin.id, 'status', e.target.checked)}
                  />
                </div>
             </div>
             
             <div className='col-lg-4 card-body bg-light'>
                <p><strong className='headings-color'>Transfer Mode</strong></p>
             </div>
             <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
                <select
                  className='form-select form-select-solid fw-bolder'
                  value={plugin.transferMode}
                  onChange={(e) => handlePluginChange(plugin.id, 'transferMode', e.target.value)}
                  onBlur={handlePluginBlur}
                >
                  <option value={'neft'}>NEFT</option>
                  <option value={'imps'}>IMPS</option>
                </select>
             </div>
             
             {Object.keys(plugin.keys || {}).map(key => (
               <React.Fragment key={key}>
                 <div className='col-lg-4 card-body bg-light'>
                    <p><strong className='headings-color'>{key.toUpperCase()}</strong></p>
                 </div>
                 <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
                    <input
                      type='text'
                      className='form-control'
                      value={plugin.keys[key]}
                      onChange={(e) => handlePluginChange(plugin.id, key, e.target.value, true)}
                      onBlur={handlePluginBlur}
                    />
                 </div>
               </React.Fragment>
             ))}
          </div>
        ))}
        
      </div>
    </div>
  )
}

export default PayoutPlugin
